import * as types from '@/store/mutation-types'
import api from '@/services/api/adminAds'
import apiFbId from '@/services/api/findMyFbId'
import { buildSuccess, handleError } from '@/utils/utils.js'
import router from '@/router'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'
// import AWS from 'aws-sdk';

const getters = {
  ads: state => state.ads,
  totalAds: state => state.totalAds
}

const actions = {

  getUploadUrl( { commit }, payload) {

    checkIfTokenNeedsRefresh()
    commit(types.SHOW_LOADING, true)
    return new Promise((resolve, reject) => { 
    
      api
        .getUploadUrl(payload)
        .then(response => {
          if (response.status === 200) { 
            console.log('getUploadUrl response: ', JSON.stringify ( response ,null,2) )
            return resolve(response.data.url)
          }
        })
        .catch(error => {
        handleError(error, commit, reject)
      })

    })

  },

  uploadFile({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest()
        xhr.open(params.op, params.url)
        xhr.setRequestHeader('Content-Type', params.contentType)
        xhr.setRequestHeader('Content-Disposition', 'inline')

        xhr.upload.onprogress = function (event) {
          if (event.lengthComputable) {
            const percentage = (event.loaded / event.total) * 100
            commit(types.UPLOAD_PERCENT, percentage)
          }
        }

        xhr.onload = function () {
          console.log('Status:', xhr.status)
          console.log('Response:', xhr.responseText)
          console.log('URL de upload:', params.url)

          if (xhr.status >= 200 && xhr.status < 300) {
            commit(types.UPLOAD_PERCENT, 0)
            resolve(true)
          } else {
            console.log('Falha no upload')
            commit(types.UPLOAD_PERCENT, 0)
            handleError(xhr.statusText, commit, reject)
            reject(false)
          }
        }

        xhr.onerror = function () {
          console.error('Erro no upload:', xhr.statusText)
          commit(types.UPLOAD_PERCENT, 0)
          reject(xhr.statusText)
        }

        xhr.send(params.formData)
      } catch (error) {
        console.error('Erro no upload:', error)
        reject(error)
      }
    })
  },      
    

  async uploadToS3AndSave({ commit }, payload){
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_LOADING, true)

      const shouldSave = await actions.uploadToS3({ commit }, {
        Bucket: payload.Bucket,
        Key: payload.Key,
        ACL: payload.ACL,
        Body: payload.Body
      })

      if(shouldSave){
        await actions.saveAds({ commit }, {
          identity: payload.identity,
          campanha: payload.campanha,
          nomeArquivo: payload.nomeArquivo,
          urlDestino: payload.urlDestino ,
          urlApp: payload.urlApp,
          diasSemana: payload.diasSemana,
          intervalo: payload.intervalo,
          horas: payload.horas,
          ativo: payload.ativo,
          Bucket: payload.Bucket,
          Key: payload.Key
        })
      }
  },

  // uploadToS3({ commit }, paramsS3) {
  //   return new Promise((resolve, reject) => {

  //     const s3 = new AWS.S3();

  //     s3.config.update({ accessKeyId: S3AccessKey, secretAccessKey: S3SecretAccessKey })
  //     s3.config.region = 'us-east-1'

  //     s3.putObject(paramsS3, function(err){
  //       if (err){
  //         handleError(err, commit, reject)
  //         reject(false)
  //       }
  //       else{
  //         resolve(true)
  //       }
  //     })
  //   })
  // },


  getFbId(params = {}){
    return new Promise((resolve, reject) => {
    apiFbId
      .getFbId(params)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data.id)
        }
      })
      .catch(error => {
        console.log('Falha: '+error)
        // 'Falha ao obter Facebook Id'
        reject
      })
    })
  },

  saveAds({ commit }, params){
    return new Promise((resolve, reject) => {
    api
      .saveAds({
        identity: params.identity,
        campanha: params.campanha,
        nomeArquivo: params.nomeArquivo ,
        urlDestino: params.urlDestino ,
        urlApp: params.urlApp,
        diasSemana: params.diasSemana,
        intervalo: params.intervalo,
        horas: params.horas,
        ativo: params.ativo
      })
      .then(response => {
        if (response.status === 201) {
          buildSuccess(
            {msg: 'common.SAVED_SUCCESSFULLY'}, commit, resolve
          ),
          router.push({
            name: 'adminads'
          })
        }
      })
      .catch(error => {
        handleError(error, commit, reject)
      })
    })
  },

  getAds({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      commit(types.SHOW_TOP_LOADING, true)
      api
        .getAds(payload)
        .then(response => {
          if (response.status === 200) {
            commit(types.ADS, response.data.docs)
            commit(types.TOTAL_ADS, response.data.totalDocs)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  editAds({ commit }, payload) {

    return new Promise((resolve, reject) => {
      const data = {
        _id: payload._id,
        campanha: payload.campanha,
        identity: payload.identity,
        nomeArquivo: payload.nomeArquivo,
        urlDestino: payload.urlDestino,
        urlApp: payload.urlApp,
        diasSemana: payload.diasSemana,
        intervalo: payload.intervalo,
        horas: payload.horas,
        ativo: true
      }
      api
        .editAds(payload._id, data)
        .then(response => {
          if (response.status === 200) {
            buildSuccess(
              {
                msg: 'common.SAVED_SUCCESSFULLY'
              },
              commit,
              resolve,
              router.push({
                name: 'adminads'
              })
            )
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  disableAds({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve) => {
      const data = {
        _id: payload._id,
        campanha: payload.campanha,
        identity: payload.identity,
        nomeArquivo: payload.nomeArquivo,
        urlDestino: payload.urlDestino,
        urlApp: payload.urlApp,
        diasSemana: payload.diasSemana,
        intervalo: payload.intervalo,
        horas: payload.horas,
        ativo: payload.ativo
      }
      api
        .editAds(payload._id, data)
        .then(response => {
          if (response.status === 200) {
            commit,
            resolve()
          }
        })
        .catch(error => {
          console.log('Erro ao desativar: '+error)
        })
    })
  },
  // deleteAds({ commit }, payload) {
  //   checkIfTokenNeedsRefresh()
  //   return new Promise((resolve, reject) => {
  //     api
  //       .deleteAds(payload)
  //       .then(response => {
  //         if (response.status === 200) {
  //           buildSuccess(
  //             {
  //               msg: 'common.DELETED_SUCCESSFULLY'
  //             },
  //             commit,
  //             resolve
  //           )
  //         }
  //       })
  //       .catch(error => {
  //         handleError(error, commit, reject)
  //       })
  //   })
  // }
}

const mutations = {
  [types.ADS](state, ads) {
    state.ads = ads
  },
  [types.TOTAL_ADS](state, value) {
    state.totalAds = value
  },
  [types.UPLOAD_PERCENT](state, value) {
    state.uploadPercent = value
  },
}

const state = {
  ads: [],
  totalAds: 0,
  uploadPercent: 0
}

export default {
  state,
  getters,
  actions,
  mutations
}
